import { gql } from '@apollo/client';
import TASK_TEMPLATE_FRAGMENT from './TaskTemplateFragment.graphql';
import TASK_LIST_SECTION_TEMPLATE_FRAGMENT from './TaskListSectionTemplateFragment.graphql';

export default gql`
  fragment TaskListTemplateFragment on TaskListTemplate {
    id
    name
    category
    description
    isOwner
    __typename
    taskTemplates(withoutSection: true) {
      __typename
      nodes {
        ...TaskTemplateFragment
      }
    }
    taskListSectionTemplates {
      __typename
      nodes {
        ...TaskListSectionTemplateFragment
      }
    }
  }
  ${TASK_TEMPLATE_FRAGMENT}
  ${TASK_LIST_SECTION_TEMPLATE_FRAGMENT}
`;
